import { useState } from "react";

const MAX_BAR_WIDTH = 65;

export default function StockTable({ data }) {
  const [activeRow, setActiveRow] = useState(null);

  const entries = Object.entries(data || {});
  const maxWeight = entries.reduce((max, [, v]) => Math.max(max, Math.abs(v.Weight || 0)), 0);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <style>{`
        .st-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 4px;
        }
        .st-table th {
          color: #aeaeae;
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          padding: 0 11px 6px;
        }
        .st-table td {
          padding: 14px 11px;
          font-size: 12px;
          color: #ffffff;
        }
        .st-row-odd td { background: rgba(73, 73, 73, 0.66); }
        .st-row-odd td:first-child { border-radius: 10px 0 0 10px; }
        .st-row-odd td:last-child  { border-radius: 0 10px 10px 0; }
        .st-row-even td { background: transparent; }
        .st-row-active td { background: rgba(73, 73, 73, 0.9) !important; }
        .st-row-active td:first-child { border-radius: 10px 0 0 10px; }
        .st-row-active td:last-child  { border-radius: 0 10px 10px 0; }
      `}</style>

      <h3 style={{
        fontSize: "14px",
        fontWeight: 600,
        color: "#ffffff",
        margin: "0 0 16px 0",
        flexShrink: 0,
      }}>
        Asset Allocation
      </h3>

      <div style={{ overflowY: "auto", overflowX: "hidden", height: "fit-content" }}>
        <table className="st-table">
          <thead>
            <tr>
              <th>Permno</th>
              <th>Ticker</th>
              <th style={{ width: "200px" }}>Weight</th>
              <th>Returns</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([permno, value], index) => {
              const isActive = activeRow === permno;
              const rowClass = isActive
                ? "st-row-active"
                : index % 2 === 0
                ? "st-row-odd"
                : "st-row-even";
              const returns = value.Returns ?? 0;
              const weight = value.Weight ?? 0;
              const barWidth = maxWeight > 0
                ? (Math.abs(weight) / maxWeight) * MAX_BAR_WIDTH
                : 0;

              return (
                <tr
                  key={permno}
                  className={rowClass}
                  onMouseEnter={() => setActiveRow(permno)}
                  onMouseLeave={() => setActiveRow(null)}
                >
                  <td>{permno}</td>
                  <td>{value.Ticker}</td>
                  <td style={{ width: "200px" }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                      {weight.toFixed(2)}
                      <span style={{ position: "relative", display: "inline-block", width: `${MAX_BAR_WIDTH}px`, height: "6px" }}>
                        <span style={{ position: "absolute", inset: 0, background: "#282828", borderRadius: "3px" }} />
                        <span style={{ position: "absolute", top: 0, left: 0, bottom: 0, width: `${barWidth}px`, background: "#e2e2e2", borderRadius: "3px" }} />
                      </span>
                    </span>
                  </td>
                  <td style={{ color: returns >= 0 ? "#00c89d" : "#ff5e65", fontWeight: 400, textAlign: "left" }}>
                    {returns.toFixed(3)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
